import React, { useState, useEffect } from 'react';

interface SvgImageProps {
    svgApiUrl: string; // The API endpoint returning SVG XML
    className?: string;
    alt?: string;       // Alt text for the image
}

const SvgImage = ({ svgApiUrl, className, alt }: SvgImageProps) => {
    const [dataUri, setDataUri] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);
    const [onError, setOnError] = useState<boolean>(false);

    useEffect(() => {
        const fetchSvgAndCreateDataUri = async () => {
            setLoading(true);
            setError(null);
            try {
                const response = await fetch(svgApiUrl);
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const svgXml = await response.text();

                // URL-encode the SVG content (important for special characters)
                const encodedSvg = encodeURIComponent(svgXml);
                const newUri = `data:image/svg+xml;utf8,${encodedSvg}`;
                setDataUri(newUri);
            } catch (err: any) {
                setError(`Failed to load SVG image: ${err.message}`);
            } finally {
                setLoading(false);
            }
        };

        fetchSvgAndCreateDataUri();
    }, [svgApiUrl]); // Re-fetch if svgApiUrl changes

    const handleOnError = () => {
        setOnError(true);
    };

    return (
        !loading ?
            <img
                src={dataUri}
                className={className}
                alt={alt}
                onError={handleOnError}
            /> : null
    )
};

export default SvgImage;